import React from "react";

// Tiny inline SVG sparkline (no external lib).
export const Sparkline = ({ data = [], width = 110, height = 32, color = "#6366F1", fill = true }) => {
  if (!data.length) return null;
  // Single-point datasets: pad to a flat 2-point line so SVG never receives NaN/Infinity.
  const safe = data.length === 1 ? [data[0], data[0]] : data;
  const min = Math.min(...safe);
  const max = Math.max(...safe);
  const range = max - min || 1;
  const step = width / (safe.length - 1);
  const points = safe
    .map((v, i) => `${i * step},${height - ((v - min) / range) * (height - 4) - 2}`)
    .join(" ");
  const areaPoints = `0,${height} ${points} ${width},${height}`;
  return (
    <svg width={width} height={height} className="block">
      {fill && (
        <polygon points={areaPoints} fill={color} opacity="0.12" />
      )}
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={width} cy={height - ((safe[safe.length - 1] - min) / range) * (height - 4) - 2} r="2.5" fill={color} />
    </svg>
  );
};
